import Vue from 'vue';
import { directive as onClickaway } from 'vue-clickaway';

Vue.directive('onClickaway', onClickaway);
